import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { DEVICE_SEARCH_FILTER_STORAGE_KEY } from '../../../layouts/internal/components/device-search/device-search-filter-storage.constants';
import { LifecyclesService } from '../lifecycle/lifecycle.service';

@Injectable({ providedIn: 'root' })
export class DeviceSearchFilterCleanupService {
  constructor(lifecyclesService: LifecyclesService) {
    const clear = () => {
      sessionStorage.removeItem(DEVICE_SEARCH_FILTER_STORAGE_KEY);
      return of(undefined);
    };
    lifecyclesService.addPreAuthHook(clear);
    lifecyclesService.addPreLogoutHook(clear);
  }
}
